import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

const formatTime = value => {
  if (value) {
    // const timeArray = value
    //   .split(':')
    //   .slice(0, -1)
    //   .join(':');

    const timeArray = value.split(':');

    if (timeArray.length > 2) {
      const hour = timeArray[0];
      const min = timeArray[1];
      if (parseInt(hour, 10) > 12) {
        return `${parseInt(hour, 10) - 12}:${min} pm`;
      }
      return `${hour}:${min} am`;
    }
    return value;
  }
};

class PropertyDetails extends React.Component {
  render() {
    const hotel = this.props.hotel;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 1,
    });

    const checkIn = formatTime(hotel.check_in);
    const checkOut = formatTime(hotel.check_out);

    const taxRate = formatter.format(hotel.tax_rate);

    return (
      <div className="row">
        <div className="col-md-12">
          <h4 className="hotel-highlight">
            Details <Button onClick={this.props.handleEdit}>Edit</Button>
          </h4>
        </div>
        <div className="col-md-4">
          <p>AAA Rating: {hotel.stars}</p>
          <p>Check-in Time: {checkIn}</p>
          <p>Check-out Time: {checkOut}</p>
          <p>Number of Rooms: {hotel.room_count}</p>
          <p>Number of Floors: {hotel.floors}</p>
        </div>
        <div className="col-md-4">
          <p>Currency: {hotel.currency}</p>
          <p>Tax Rate: {taxRate}</p>
          <p>Resort Fee: {hotel.resort_fee}</p>
        </div>
        <div className="col-md-12">
          <h4 className="hotel-highlight">Bus Parking</h4>
        </div>
        <div className="col-md-12">
          <p>Capacity: {hotel.bus_capacity}</p>
          <p>Notes: {hotel.bus_parking}</p>
        </div>
      </div>
    );
  }
}
PropertyDetails.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
};
export default PropertyDetails;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyDetailsView.js